module.exports = __webpack_public_path__ + "img/kuai.d0a5d36b.png";